const updates = [
  {
    date: '07-30',
    tag: '新片上线',
    title: '《流浪地球3》高清版已上线',
    desc: '国产科幻巨制续作，视觉特效全面升级，现已支持4K画质在线观看。',
    tagColor: 'primary',
  },
  {
    date: '07-30',
    tag: '剧集更新',
    title: '《庆余年》第二季全集更新完毕',
    desc: '范闲归来，朝堂权谋再起波澜，全集46集一次性放出。',
    tagColor: 'accent',
  },
  {
    date: '07-29',
    tag: '综艺上新',
    title: '《奔跑吧》第十二季最新一期已更新',
    desc: '本期飞行嘉宾阵容豪华，笑点密集不容错过。',
    tagColor: 'secondary',
  },
  {
    date: '07-29',
    tag: '动漫更新',
    title: '《咒术回战》第三季第8话已上线',
    desc: '涩谷事变篇高潮迭起，战斗场面制作精良。',
    tagColor: 'primary',
  },
  {
    date: '07-28',
    tag: '韩剧更新',
    title: '《背着善宰跑》第12集已更新',
    desc: '时空穿越浪漫爱情剧，收视率持续攀升中。',
    tagColor: 'accent',
  },
  {
    date: '07-28',
    tag: '新片上线',
    title: '《沙丘3》高清中字版已上线',
    desc: '史诗科幻系列终章，保罗的传奇之旅迎来最终结局。',
    tagColor: 'primary',
  },
  {
    date: '07-27',
    tag: '美剧更新',
    title: '《龙之家族》第二季第6集已更新',
    desc: '血龙狂舞愈演愈烈，坦格利安家族内战全面爆发。',
    tagColor: 'secondary',
  },
  {
    date: '07-27',
    tag: '纪录片',
    title: '《舌尖上的中国》第五季全集上线',
    desc: '全新美食探索之旅，带你领略中国饮食文化的深厚底蕴。',
    tagColor: 'accent',
  },
  {
    date: '07-26',
    tag: '剧集更新',
    title: '《三体：大史》衍生剧全集上线',
    desc: '大史独立故事线，硬核科幻与人性探索的完美结合。',
    tagColor: 'primary',
  },
];

const tagColorMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-700',
  secondary: 'bg-secondary-100 text-secondary-700',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
            最新动态
          </h2>
          <p className="mt-3 text-sm text-foreground-500">影视资源每日更新，精彩内容不错过</p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 md:pl-10 border-l-2 border-primary-200">
            {updates.map((item, idx) => (
              <div key={idx} className="relative pb-8 last:pb-0">
                <div className="absolute -left-[25px] md:-left-[29px] w-3 h-3 rounded-full bg-primary-500 ring-4 ring-background-100"></div>
                <div className="flex flex-wrap items-center gap-2 mb-2">
                  <span className="text-xs text-foreground-400 font-medium">{item.date}</span>
                  <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${tagColorMap[item.tagColor]}`}>
                    {item.tag}
                  </span>
                </div>
                <h3 className="font-heading font-semibold text-base text-foreground-900">
                  {item.title}
                </h3>
                <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}